angular.module('public.security-manager.employee').component('gccsEmployeeClientApproveClientTitle', {
  template: require('./template.pug'),
  transclude: true,
  controller: 'EmployeeClientApproveClientTitleController',
  bindings: {
    title: '@',
    count: '<'
  }
});
